<template>
  <div class="table-container">
    <a-table class="table dataTable no-footer" :columns="visibleCloumns" :data-source="data"
      :row-selection="data.length ? rowSelection : null" :pagination="false" @change="handleTableSortChange">
      <template #headerCell="{ column }">
        <span draggable="true" @dragstart="dragStart(column.key)" @dragover.prevent @drop="drop(column.key)" style="cursor: grab;display: block;
    padding: 0 10px;
   ">
          {{ column.title }}
        </span>
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'Star'">
          <div class="set-star rating-select"><i class="fa fa-star"></i></div>
        </template>
        <template v-else-if="column.key === 'opp_meter_opportunity_nr_auto'">
          <div>
            <a :href="$router.resolve({
              path: `/crm/meter-opportunities-edit/${record.opportunity_id}`,
            }).href" target="_blank" title="Opp Number" class="title-name">
              {{
                record.opp_meter_opportunity_nr_auto
              }}
            </a>
          </div>
        </template>
        <template v-if="column.key === 'org_name'">
          <router-link
            :to="{ path: '/crm/organisation-details', query: { ter_Id: record.territory_id, org_Id: record.organization_id, opp_Id: record.opportunity_id, for: 'opportunities' } }"
            class="title-name">{{
              record.org_name
            }}</router-link>
        </template>

        <template v-else-if="column.key === 'opp_sales_responsible'">
          <div>
            <span class="text-capitalize">{{ record.opp_sales_responsible }}</span>
          </div>
        </template>
        <template v-else-if="column.key === 'action'">
          <div class="icon-field">
            <!-- kanban: true, -->
            <a :href="$router.resolve({
              path: `/crm/meter-opportunities-edit/${record.opportunity_id}`
            }).href" target="_blank" title="Edit" class="btn table_action_btn">
              <i class="ti ti-edit"></i> Edit
            </a>

            <router-link
              :to="{ path: '/quoting', query: { opp_Id: record.opportunity_id, for: record.opp_main_production_service } }"
              v-if="record.is_valid !== 0 && permissions.includes('Quoting')" class="btn table_action_btn ms-2"> <i
                class="ti-bar-chart"></i> Get
              Quote</router-link>
            <router-link
              :to="{ path: '/crm/quoted-price-list', query: { ter_Id: record.territory_id, org_Id: record.organization_id, opp_Id: record.opportunity_id } }"
              v-if="record.quotes_count !== 0 && permissions.includes('Quoting')" class="btn table_action_btn ms-2"> <i
                class="ion-pricetags"></i> Quoted
              Prices</router-link>
          </div>
        </template>
      </template>
    </a-table>
  </div>

  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
  </div>

</template>

<script>
import {
  ref,
  onMounted,
  computed,
  toRefs,
  watch
} from 'vue';
import {
  useRouter
} from 'vue-router';
import { mapGetters, mapActions, useStore } from 'vuex';
import apiClient from '@/axios';
import { formatStrategyValues } from 'ant-design-vue/es/vc-tree-select/utils/strategyUtil';

export default {
  props: {
    searchOppQuery: String,
    date: String,
    pipeline: String,
    date_range: String,
    filterData: Object,
    columnOptions: Array,
    selectedColumns: Array,
    moduleId: String,
    next_update:String
  },
  data() {
    return {
      // columns,
      data: [],
      selectedUserId: null,
      showDeleteModal: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      rowSelection: {
        onChange: () => { },
        onSelect: () => { },
        onSelectAll: () => { },
      },
    };
  },
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();
    const data = ref([]);
    const column = ref([]);
    const module_data = ref([])
    const { moduleId } = toRefs(props);
    // const permissions = ref(JSON.parse(localStorage.getItem('user')).permissions || [])
    const permissions = computed(() => {
      const user = store.getters['auth/user']
      return user.permissions;
    })
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const sorter = ref({
      key: "", // Default sort key
      order: "", // Default order
    });
    let draggedColumnKey = null;
    const visibleCloumns = ref([])

    const dragStart = (key) => {
      draggedColumnKey = key;
    };

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });


    const drop = (targetKey) => {
      if (draggedColumnKey !== targetKey) {
        const oldIndex = visibleCloumns.value.findIndex(col => col.key === draggedColumnKey);
        const newIndex = visibleCloumns.value.findIndex(col => col.key === targetKey);
        const movedColumn = visibleCloumns.value.splice(oldIndex, 1)[0];
        visibleCloumns.value.splice(newIndex, 0, movedColumn);
        saveFieldOrder();
      }
    };
    const fetchOpportunities = async (page) => {
      if (typeof page === 'number' && Number.isFinite(page)) {
        pagination.value.current = page;
      }
      try {
        const response = await apiClient.get('/opportunities', {
          params: {
            search: props.searchOppQuery,
            page: pagination.value.current,
            pageSize: pagination.value.pageSize,
            start_date: formateDate(props.date?.[0]),
            end_date: formateDate(props.date?.[1]),
            pipeline_level: props.pipeline,
            date_range: props.date_range,
            opp_type: props.filterData.opp_type,
            sort_field: sorter.value.key,
            sort_order: sorter.value.order,
            next_update: props.next_update
          },
        });
        if (response.data.status) {
          // data.value = response.data.data.data.map((fields) => {
          //   return fields.fields
          // });

          data.value = response.data.data.data.map((item) => {
          const formattedFields = {}

          for (const [key, value] of Object.entries(item.fields)) {
            if (typeof value === 'string' && value.trim() !== '') {
              if (value === value.toLowerCase()) {
                // Only convert if value is all lowercase
                formattedFields[key] = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
              } else {
                formattedFields[key] = value // leave as is
              }
            } else {
              formattedFields[key] = value // preserve null, numbers, etc.
            }
          }

          return formattedFields
        })

          if (props.selectedColumns?.length === 0 && props.selectedColumns?.value?.length === undefined) {
            await fetchModuleData(props.moduleId)
          }


          let dynamicColumns = []

          if (module_data.value?.length > 0) {
            module_data.value.map((org) => {
              return org.children.map((item) => {
                const label = org.label.substr(0, 1).toUpperCase() + org.label.substr(1, 2);
                const itemLabel = item.label.substr(0, 1).toUpperCase() + item.label.substr(1);
                dynamicColumns.push({
                  label: `${org.label.substr(0, 1).toUpperCase() + org.label.substr(1)}: ${item.label.substr(0, 1).toUpperCase() + item.label.substr(1)}`,
                  title: `${label}. ${itemLabel}`,
                  field: item.field,
                  dataIndex: item.field,
                  key: item.field,
                  // sorter: (a, b) => a[item.field]?.toString().localeCompare(b[item.field]?.toString()),
                  sorter: (a, b) => {
                    const aValue = a[item.field];
                    const bValue = b[item.field];

                    if (!aValue || !bValue) return 0;

                    // Numeric sort
                    if (!isNaN(aValue) && !isNaN(bValue)) {
                      return Number(aValue) - Number(bValue);
                    }

                    const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
                    const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;

                    if (isoDateRegex.test(aValue) && isoDateRegex.test(bValue)) {
                      return new Date(aValue).getTime() - new Date(bValue).getTime();
                    }

                    if (ddMmYyyyRegex.test(aValue) && ddMmYyyyRegex.test(bValue)) {
                      const parseDate = (dateStr) => {
                        const [day, month, year] = dateStr.split('/').map(Number);
                        return new Date(year, month - 1, day);
                      };

                      return parseDate(aValue).getTime() - parseDate(bValue).getTime();
                    }

                    // Default string sort
                    return aValue.toString().localeCompare(bValue.toString());
                  }
                })

              });
            })

            // Define columns in an array for better maintainability
            const columnDefinitions = [
              { title: "Next Update Latest Date", dataIndex: "next_update_latest_date", key: "next_update_latest_date" },
              { title: "Next Update Latest Time", dataIndex: "next_update_latest_time", key: "next_update_latest_time" },
              { title: "Contract End Date (Days)", dataIndex: "contract_end_date_days", key: "contract_end_date_days" },
              { title: "Contract End Date", dataIndex: "contract_end_date", key: "contract_end_date" }
            ];

            // Add dynamic columns with sorting
            const dynamicCols = columnDefinitions.map((col) => {
              const cols = {
                ...col,
                label: col.title,
                sorter: (a, b) => {
                  const aValue = a[col.dataIndex] ?? "";
                  const bValue = b[col.dataIndex] ?? "";
                  return aValue.localeCompare(bValue);
                }
              }
              dynamicColumns.push(cols)
            });

            // Ensure the "Action" column is always at the end
            dynamicColumns.push({
              title: "Action",
              label: "Action",
              dataIndex: "Action",
              key: "action",
              // fixed: "right", width: 200
            });

            column.value = dynamicColumns;

            // props.columnOptions.value = dynamicColumns.map((col) => ({
            //   label: col.label,
            //   value: col.key,
            // }));

            const columnKeys = [
              "opp_meter_opportunity_nr_auto",
              "org_name",
              "opp_sales_responsible",
              "opp_pipeline_level",
              "next_update_latest_date",
              "next_update_latest_time",
              "opp_opp_type",
              "opp_sc_forecast_or_amended_annual_consumption",
              "contract_end_date_days",
              "opp_contract_end_date",
            ];

            // Filter and maintain order as per columnKeys
            const prioritizedColumns = columnKeys
              .map(key => dynamicColumns.find(col => col.key === key))
              .filter(Boolean); // Remove undefined values if any key is not found

            const otherColumns = dynamicColumns.filter(col => !columnKeys.includes(col.key));

            // Merge prioritized columns first, then others
            const orderedColumns = [...prioritizedColumns, ...otherColumns];

            // Assign the ordered columns to columnOptions
            props.columnOptions.value = orderedColumns
              .filter(col => col.key !== "action") // Exclude 'action' column
              .map(col => ({
                label: col.label,
                value: col.key,
              }));

            if (props.selectedColumns?.length === 0 && visibleCloumns.value.length === 0 && props.selectedColumns?.value?.length === undefined) {
              props.selectedColumns.value = props.columnOptions.value
                .slice(0, 5)
                .map(option => option.value);
            } else {
              props.selectedColumns.value = visibleCloumns.value
                .map((option) => option.key);
            }

          }

          pagination.value.total = response.data.data.total;
        } else {
          console.error("Failed to fetch opportunities:", response);
        }
      } catch (error) {
        console.error("Error fetching opportunities:", error);
      }
    };

    const fetchModuleData = async (id) => {
      try {
        // const data = await store.dispatch("report/fetchModuleData", id);
        const response = await apiClient.get(`/report/module/${id}/fields?type=filters`);
        if (response.data.status) {
          module_data.value = response.data.data;
        }
      }
      catch (error) {
        console.error("Error fetching report data:", error);
      }
    };
    // Function to convert date format
    const formatDate = (date) => {
      if (date) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      }
    };
    const handleTableChange = (current, pageSize, sort) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      // if (sort?.order) {
      //   sorter.value.key = sort.columnKey;
      //   sorter.value.order =
      //     sort.order === "ascend" ? "ASC" : sort.order === "descend" ? "DESC" : "";
      // } else {
      //   sorter.value.key = '';
      //   sorter.value.order = "";
      // }
      fetchOpportunities();
    };

    const handleTableSortChange = (page, filters, sort) => {
      // pagination.value.current = Number(page.current) || 1;
      // pagination.value.pageSize = Number(page.pageSize) || 10;
      if (sort?.order) {
        sorter.value.key = sort.columnKey;
        sorter.value.order =
          sort.order === "ascend" ? "ASC" : sort.order === "descend" ? "DESC" : "";
      } else {
        sorter.value.key = '';
        sorter.value.order = "";
      }

      fetchOpportunities();
    };

    const formateDate = (dateString) => {
      let date
      if (!dateString) {
        date = new Date(props.date?.[0])
      } else {
        date = new Date(dateString);
      }
      if (isNaN(date.getTime())) {
        return null;
      }

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');

      const formattedDate = `${yyyy}-${mm}-${dd}`;
      return formattedDate;
    };


    const openEditModal = (id) => {
      router.push({
        path: "/crm/create-organisation",
        query: {
          org_Id: id
        },
      });
    };

    watch(
      () => props.selectedColumns.value,
      (selectedColsProp, oldProps) => {
        let selectedCols =
          !selectedColsProp || selectedColsProp.length === 0
            ? column.value
            : selectedColsProp
              .map((key) => column.value.find((col) => col.key === key))
              .filter(Boolean); // Remove undefined values

        // Extract the "action" column separately (to add at the end)
        const actionColumn = column.value.find((col) => col.key === "action");
        if (actionColumn && !selectedCols.some((col) => col.key === "action")) {
          selectedCols.push(actionColumn);
        }

        // Filter out specific columns if all values in data are null/undefined
        selectedCols = selectedCols.filter((col) => {
          if (
            col.dataIndex === "contract_end_date" ||
            col.dataIndex === "contract_end_date_days"
          ) {
            return data.value.some(
              (row) =>
                row[col.dataIndex] !== null && row[col.dataIndex] !== undefined
            );
          }
          return true;
        });

        if (visibleCloumns.value.length > 0) {

          const selectedKeys = new Set(selectedCols.map(col => col.key));

          // Remove columns not in selectedCols (except "action")
          visibleCloumns.value = visibleCloumns.value.filter(
            col => selectedKeys.has(col.key) || col.key === "action"
          );

          // Add missing columns at the end
          const visibleKeys = new Set(visibleCloumns.value.map(col => col.key));
          const newExtraCols = selectedCols.filter(col => !visibleKeys.has(col.key));

          visibleCloumns.value.push(...newExtraCols);
          if(oldProps){
            saveFieldOrder();
          }
        } else {
          visibleCloumns.value = [...selectedCols];
        }
      },
      { immediate: true, deep: true }
    );


    const saveFieldOrder = async () => {
      const payload = {
        form_key: 'opportunity_listing',
        fields_json: visibleCloumns.value
      }
      const response = await store.dispatch("opportunity/changeColumns", payload)
    };

    const fetchColumns = async () => {
      const res = await store.dispatch("opportunity/getColumnsData", 'opportunity_listing');
      if (res.data && Object.keys(res.data).length > 0) {
        const fields = res.data.fields_json;

        visibleCloumns.value = fields.map(item => ({
          ...item,
          sorter: (a, b) => {
            const aValue = a[item.field];
            const bValue = b[item.field];

            if (!aValue || !bValue) return 0;

            // Check if value is a valid number
            if (!isNaN(aValue) && !isNaN(bValue)) {
              return Number(aValue) - Number(bValue);
            }

            const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
            const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;

            if (isoDateRegex.test(aValue) && isoDateRegex.test(bValue)) {
              return new Date(aValue).getTime() - new Date(bValue).getTime();
            }

            if (ddMmYyyyRegex.test(aValue) && ddMmYyyyRegex.test(bValue)) {
              const parseDate = (dateStr) => {
                const [day, month, year] = dateStr.split('/').map(Number);
                return new Date(year, month - 1, day);
              };

              return parseDate(aValue).getTime() - parseDate(bValue).getTime();
            }

            // Default to string sorting
            return aValue.toString().localeCompare(bValue.toString());
          }
        }));
      }
    };

    onMounted(async () => {
      await fetchColumns()
    })

    // onMounted(async () => {
    //  await fetchOpportunities();
    // });

    // watch(moduleId, async (newVal) => {
    //   if (newVal) {
    //     await fetchModuleData(newVal);
    //   }
    // });

    // watch(async () => {
    //     await fetchModuleData(moduleId.value);
    // });

    return {
      data,
      pagination,
      // filterColumns,
      // filteredColumns,
      formatDate,
      fetchOpportunities,
      handleTableChange,
      openEditModal,
      formateDate,
      dragStart,
      drop,
      column,
      fetchModuleData,
      module_data,
      permissions,
      pageSizeOptions,
      visibleCloumns,
      saveFieldOrder,
      fetchColumns,
      handleTableSortChange,
      sorter
    };
  },
};
</script>
<!-- <style>
.table-container {
  max-height: 100%, ;
  overflow-y: scroll;
  margin-bottom: 25px;
}

.table-container::-webkit-scrollbar {
  width: 0;
}

.pagination-container {
  display: flex;
  justify-content: end;
  margin-top: 10px;
  text-align: center;
}
</style> -->
